export default "__VITE_ASSET__OlQSYMwE__"